import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class OutlineTop extends Vue {
    @Prop() readonly courseName: string;
    handleCloseClick() {
        this.$router.push({ path: "/myRoom/course" });
    }
}
//@ts-ignore
export { default as OutlineTop } from "./index.vue";
